import { render, staticRenderFns } from "./iDSRequestStorage.vue?vue&type=template&id=281e1154"
import script from "./iDSRequestStorage.vue?vue&type=script&lang=js"
export * from "./iDSRequestStorage.vue?vue&type=script&lang=js"
import style0 from "./iDSRequestStorage.vue?vue&type=style&index=0&id=281e1154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports